import { useState } from "react";

export default function StringDispenser(data: string[]) {
  const [index, setIndex] = useState(0);

  return () => {
    const value = data[index];
    setIndex((index + 1) % data.length);
    return value;
  }
}
